module.exports = "<re-captcha (resolved)=\"resolved($event)\" siteKey=\"6LcOuyYTAAAAAHTjFuqhA52fmfJ_j5iFk5PsfXaU\"></re-captcha>\n"


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/recaptcha/recaptcha.component.html
// module id = ../../../../../src/app/shared/recaptcha/recaptcha.component.html
// module chunks = main